<template lang="pug">
  button.reaction-button(
    v-if="valid"
    :class="classes"
  )
    template(v-if="type === 'like'")
      include ./images/like.svg
    template(v-else)
      include ./images/dislike.svg
    span.reaction-button__count {{computedCount}}
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  export default defineNuxtComponent({
    name: 'ReactionButton',

    props: {
      count: {
        type: Number as PropType<number>,
        default: 0,
      },
      type: {
        type: String as PropType<'like' | 'dislike'>,
        required: true,
      },
      active: {
        type: Boolean as PropType<boolean>,
        default: false,
      },
    },
    computed: {
      valid(): boolean {
        return ['like', 'dislike'].includes(this.type);
      },
      classes(): Record<string, boolean> {
        return {
          'reaction-button_active': this.active,
          [`reaction-button_${this.type}`]: true,
        };
      },
      computedCount(): string {
        return this.count >= 1000 ? '1к+' : this.count.toString();
      },
    },
  });
</script>

<style lang="scss">
  :root {
    --reaction-button-width: 80px;
    --reaction-button-height: 40px;
    --reaction-button-padding-left: 16px;
  }
</style>

<style lang="scss" scoped>
  $red: #f73838;
  $green: #51a822;

  .reaction-button {
    display: flex;
    padding-left: var(--reaction-button-padding-left);
    align-items: center;
    width: var(--reaction-button-width);
    height: var(--reaction-button-height);
    background: white;
    border: 1px solid #ebebeb;
    border-radius: 5px;
    cursor: pointer;

    &__count {
      @include fontSmallTextBtn;
      margin-left: 7px;
    }

    &_like {
      &.reaction-button_active {
        background: $green;
        border-color: $green;
        .reaction-button__count {
          color: white;
        }

        path[fill] {
          fill: white;
        }
      }

      &:not(.reaction-button_active) {
        @include hover {
          color: $green;

          .reaction-button__count {
            color: $green;
          }

          path[fill] {
            fill: $green;
          }
        }
      }
    }

    &_dislike {
      &.reaction-button_active {
        background: $red;
        border-color: $red;
        color: white;
        .reaction-button__count {
          color: white;
        }

        path[fill] {
          fill: white;
        }
      }

      &:not(.reaction-button_active) {
        @include hover {
          color: $red;

          .reaction-button__count {
            color: $red;
          }

          path[fill] {
            fill: $red;
          }
        }
      }
    }
  }
</style>
